import { put, takeEvery, select } from 'redux-saga/effects'

import { updateUserEmail, fetchUsersByStatusTrigger, fetchUsersTrigger } from 'store/entities/organizations/actions'

import { getOrganizationUsersFilterBy, getOrganizationUsersCurrentPage } from 'store/entities/organizations/selectors'

export function* updateFilterByAfterSingleEmailUpdate() {
  const filterValue = yield select(getOrganizationUsersFilterBy)
  const userPageBeforeFetch: number = yield select(getOrganizationUsersCurrentPage)
  yield put(fetchUsersTrigger({ search: filterValue, page: userPageBeforeFetch }))
  yield put(fetchUsersByStatusTrigger())
}

export default function* updateFilterByAfterSingleEmailUpdateSaga() {
  yield takeEvery([updateUserEmail.success.toString()], updateFilterByAfterSingleEmailUpdate)
}
